import { GetCustomerMachineDetails } from '../adapters/HospitalDashboard/GetCustomerMachineDetails';

export const fetchCustomerMachineDetails = () => (
  new Promise((resolve, reject) => {
    GetCustomerMachineDetails()
      .then((res) => {
        if (res && res.data && res.status === 200) {
          const payload = res.data.data;
          resolve(Array.isArray(payload) ? payload : []);
          return;
        }
        reject(res?.data?.error?.message || 'error occured');
      })
      .catch((err) => reject(err));
  })
);
